import type { SiteConfig } from '@/types'

/**
 * The public origin, used to build absolute Open Graph URLs. Set
 * NEXT_PUBLIC_SITE_URL once a custom domain is connected and this follows.
 */
const origin = (process.env.NEXT_PUBLIC_SITE_URL ?? 'https://dentrax.modulify.website').replace(/\/$/, '')

export const siteConfig: SiteConfig = {
    name: 'Astra',
    description: 'Astra is an independent brand identity studio in Paris. Identity, art direction, typography, packaging and digital branding for AURA, KIN, VANTA, ARC, NOMA and MONO.',
    placeholder: 'Brand identity, art direction and the quiet details that make a brand feel inevitable.',
    url: origin,
    ogImage: '/images/work/aura-skincare.png'
}
